import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
import loadConfig from "@Web3WalletConfig/config";
import { exportExcel } from "@utils/index";
export default {
  name: "cipherrank",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", 'setting'])
  },
  data() {
    return {
      loadConfig,
      isLock: false,
      statData: 0,
      list: [],
      isLoading: false,
      total: 0,
      total_amount: 0,
      condition: {
        page: 1,
        limit: 100,
        date: ""
      },
      chainList: []
    };
  },
  methods: {
    async getDataList() {
      this.isLoading = true;
      let rs = await this.$http.post("/cipher/rank", {
        ...this.condition
      });
      this.isLoading = false;
      if (rs.code == 0) {
        this.list = rs.data.items;
        this.total = rs.data.total;
      }
    },
    cutStr(str) {
      if (str) return str.replace("T", " ").replace(".000Z", "");
    },
    onRefresh() {
      this.getDataList();
    },
    onExport() {
      let data = this.list.map((item, index) => {
        delete item.priority;
        item.idex = index + 1;
        return item;
      });
      exportExcel(this.list, 'top100');
    },
    onPageChange(e) {
      this.condition.page = e;
      this.getDataList();
    },
    onPageSizeChange(e) {
      this.condition.limit = e;
      this.getDataList();
    },
    changeDate(v) {
      this.condition.date = v;
    }
  },
  async mounted() {
    const now = new Date();
    this.condition.date = now.getFullYear() + '-' + (now.getMonth() + 1).toString().padStart(2, '0') + '-' + now.getDate().toString().padStart(2, '0');
    this.getDataList();
  }
};